import { render, staticRenderFns } from "./ClientVehicleTab.vue?vue&type=template&id=d178acac&"
import script from "./ClientVehicleTab.vue?vue&type=script&lang=js&"
export * from "./ClientVehicleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports